import React from "react";
import Container from "@mui/material/Container";
import WidgetWrap from "../components/widgets/WidgetWrap";
// import BarGraphComp from '../components/barGraphComp';
// import BarChart from '../components/widgets/BarChart';
import BarChartCylinder from "../components/widgets/BarChartCylinder";
// import { BarChartRounded } from '@material-ui/icons';
import EventVolume from "../components/widgets/EventVolume";
import DoughnutChart from "../components/widgets/DoughnutChart";
import DoubleDonut from "../components/widgets/DoubleDonut";
import MyMapComponent from "../components/mapMarker";
import "../assets/css/mapMarker.scss";

const mapData = [
  {
    id: 21,
    vehicle: "SkutKar #21",
    type: "Car",
    battery: 24,
    availability: "available",
    TPMS: "OK",
    DTC: "P3245",
    location: {
      address: {
        city: "City1",
        country: "Country",
        line1: "Addr line 1",
        line2: "Addr line 2",
        postalCode: "13453",
        stateOrProvince: "NY",
      },
      latitude: -34.397,
      longitude: 150.644,
    },
    trackableId: "1657826963564ONP1U4K",
    alerts: [
      {
        dateTime: new Date("2022-08-06 20:12:45.442794").toUTCString(),
        type: "accident",
        typeVal: "Accident",
        value: "",
      },
      {
        dateTime: new Date("2022-07-06 20:12:45.442794").toUTCString(),
        type: "unauthorizedmovement",
        typeVal: "Unauthorized Movement",
        value: "",
      },
      {
        dateTime: new Date("2022-08-05 20:12:45.442794").toUTCString(),
        type: "battery",
        typeVal: "Battery",
        value: "9",
      },
      {
        dateTime: new Date("2022-04-06 20:12:45.442794").toUTCString(),
        type: "tpms",
        typeVal: "TPMS",
        value: "LOW(LF)",
      },
      {
        dateTime: new Date("2022-08-06 20:12:45.442794").toUTCString(),
        type: "accident",
        typeVal: "Accident",
        value: "",
      },
      {
        dateTime: new Date("2022-07-06 20:12:45.442794").toUTCString(),
        type: "unauthorizedmovement",
        typeVal: "Unauthorized Movement",
        value: "",
      },
      {
        dateTime: new Date("2022-08-05 20:12:45.442794").toUTCString(),
        type: "battery",
        typeVal: "Battery",
        value: "9",
      },
      {
        dateTime: new Date("2022-04-06 20:12:45.442794").toUTCString(),
        type: "tpms",
        typeVal: "TPMS",
        value: "LOW(LF)",
      },
    ],
  },
  {
    id: 245,
    vehicle: "SkutKar #245",
    type: "Scooter",
    battery: 50,
    availability: "reserved",
    TPMS: "OK",
    DTC: "OK",
    location: {
      address: {
        city: "City2",
        country: "Country",
        line1: "Addr line 1",
        line2: "Addr line 2",
        postalCode: "13453",
        stateOrProvince: "NY",
      },
      latitude: -34.297,
      longitude: 150.444,
    },
    trackableId: "1657900088006AX6UV3O",
    alerts: [
      {
        dateTime: new Date("2022-08-06 20:12:45.442794").toUTCString(),
        type: "accident",
        typeVal: "Accident",
        value: "",
      },
      {
        dateTime: new Date("2022-07-06 20:12:45.442794").toUTCString(),
        type: "unauthorizedmovement",
        typeVal: "Unauthorized Movement",
        value: "",
      },
      {
        dateTime: new Date("2022-08-05 20:12:45.442794").toUTCString(),
        type: "battery",
        typeVal: "Battery",
        value: "9",
      },
      {
        dateTime: new Date("2022-04-06 20:12:45.442794").toUTCString(),
        type: "tpms",
        typeVal: "TPMS",
        value: "LOW(LF)",
      },
    ],
  },
  {
    id: 22,
    vehicle: "SkutKar #22",
    type: "Car",
    battery: 78,
    availability: "available",
    TPMS: "Low(LF)",
    DTC: "OK",
    location: {
      address: {
        city: "City3",
        country: "Country",
        line1: "Addr line 1",
        line2: "Addr line 2",
        postalCode: "13453",
        stateOrProvince: "NY",
      },
      latitude: -34.397,
      longitude: -34.397,
    },
    trackableId: "165790044824192TKA5O",
    alerts: [
      {
        dateTime: new Date("2022-08-06 20:12:45.442794").toUTCString(),
        type: "accident",
        typeVal: "Accident",
        value: "",
      },
      {
        dateTime: new Date("2022-07-06 20:12:45.442794").toUTCString(),
        type: "unauthorizedmovement",
        typeVal: "Unauthorized Movement",
        value: "",
      },
      {
        dateTime: new Date("2022-08-05 20:12:45.442794").toUTCString(),
        type: "battery",
        typeVal: "Battery",
        value: "9",
      },
      {
        dateTime: new Date("2022-04-06 20:12:45.442794").toUTCString(),
        type: "tpms",
        typeVal: "TPMS",
        value: "LOW(LF)",
      },
    ],
  },
  {
    id: 232,
    vehicle: "SkutKar #232",
    type: "Car",
    battery: 78,
    availability: "available",
    TPMS: "OK",
    DTC: "OK",
    location: {
      address: {
        city: "City4",
        country: "Country",
        line1: "Addr line 1",
        line2: "Addr line 2",
        postalCode: "13453",
        stateOrProvince: "NY",
      },
      latitude: -34.257,
      longitude: 150.5,
    },
    trackableId: "1657900533286O9X4A1R",
    alerts: [
      {
        dateTime: new Date("2022-08-06 20:12:45.442794").toUTCString(),
        type: "accident",
        typeVal: "Accident",
        value: "",
      },
      {
        dateTime: new Date("2022-07-06 20:12:45.442794").toUTCString(),
        type: "unauthorizedmovement",
        typeVal: "Unauthorized Movement",
        value: "",
      },
      {
        dateTime: new Date("2022-08-05 20:12:45.442794").toUTCString(),
        type: "battery",
        typeVal: "Battery",
        value: "9",
      },
      {
        dateTime: new Date("2022-04-06 20:12:45.442794").toUTCString(),
        type: "tpms",
        typeVal: "TPMS",
        value: "LOW(LF)",
      },
    ],
  },
  {
    id: 43035,
    vehicle: "Skutr #43035",
    type: "Scooter",
    battery: 78,
    availability: "available",
    TPMS: "Low(LF)",
    DTC: "OK",
    location: {
      address: {
        city: "City5",
        country: "Country",
        line1: "Addr line 1",
        line2: "Addr line 2",
        postalCode: "13453",
        stateOrProvince: "NY",
      },
      latitude: -36.2,
      longitude: 100.5,
    },
    trackableId: "1657900674170PBJRTS5",
    alerts: [
      {
        dateTime: new Date("2022-08-06 20:12:45.442794").toUTCString(),
        type: "accident",
        typeVal: "Accident",
        value: "",
      },
      {
        dateTime: new Date("2022-07-06 20:12:45.442794").toUTCString(),
        type: "unauthorizedmovement",
        typeVal: "Unauthorized Movement",
        value: "",
      },
      {
        dateTime: new Date("2022-08-05 20:12:45.442794").toUTCString(),
        type: "battery",
        typeVal: "Battery",
        value: "9",
      },
      {
        dateTime: new Date("2022-04-06 20:12:45.442794").toUTCString(),
        type: "tpms",
        typeVal: "TPMS",
        value: "LOW(LF)",
      },
    ],
  },
  {
    id: 45,
    vehicle: "SkutKar #45",
    type: "Car",
    battery: 22,
    availability: "accident",
    TPMS: "OK",
    DTC: "OK",
    location: {
      address: {
        city: "City1",
        country: "Country",
        line1: "Addr line 1",
        line2: "Addr line 2",
        postalCode: "13453",
        stateOrProvince: "NY",
      },
      latitude: -36.1,
      longitude: 100.1,
    },
    //  trackableId: '1657900810967PLND5QI',
    trackableId: "16606185321649ZYO0DF",
    alerts: [
      {
        dateTime: new Date("2022-08-06 20:12:45.442794").toUTCString(),
        type: "accident",
        typeVal: "Accident",
        value: "",
      },
      {
        dateTime: new Date("2022-07-06 20:12:45.442794").toUTCString(),
        type: "unauthorizedmovement",
        typeVal: "Unauthorized Movement",
        value: "",
      },
      {
        dateTime: new Date("2022-08-05 20:12:45.442794").toUTCString(),
        type: "battery",
        typeVal: "Battery",
        value: "9",
      },
      {
        dateTime: new Date("2022-04-06 20:12:45.442794").toUTCString(),
        type: "tpms",
        typeVal: "TPMS",
        value: "LOW(LF)",
      },
    ],
  },
  {
    id: 39,
    vehicle: "Skutr #39",
    type: "Scooter",
    battery: 44,
    availability: "tripstarted",
    TPMS: "OK",
    DTC: "OK",
    location: {
      address: {
        city: "City2",
        country: "Country",
        line1: "Addr line 1",
        line2: "Addr line 2",
        postalCode: "13453",
        stateOrProvince: "NY",
      },
      latitude: -30.2,
      longitude: 150.5,
    },
    trackableId: "165790089413694WQN2I",
    alerts: [
      {
        dateTime: new Date("2022-08-06 20:12:45.442794").toUTCString(),
        type: "accident",
        typeVal: "Accident",
        value: "",
      },
      {
        dateTime: new Date("2022-07-06 20:12:45.442794").toUTCString(),
        type: "unauthorizedmovement",
        typeVal: "Unauthorized Movement",
        value: "",
      },
      {
        dateTime: new Date("2022-08-05 20:12:45.442794").toUTCString(),
        type: "battery",
        typeVal: "Battery",
        value: "9",
      },
      {
        dateTime: new Date("2022-04-06 20:12:45.442794").toUTCString(),
        type: "tpms",
        typeVal: "TPMS",
        value: "LOW(LF)",
      },
    ],
  },
  {
    id: 25,
    vehicle: "Skutr #25",
    type: "Car",
    battery: 44,
    availability: "tripstarted",
    TPMS: "OK",
    DTC: "OK",
    location: {
      address: {
        city: "City2",
        country: "Country",
        line1: "Addr line 1",
        line2: "Addr line 2",
        postalCode: "13453",
        stateOrProvince: "NY",
      },
      latitude: 30.1,
      longitude: 100.1,
    },
    trackableId: "1657901020419AKI98FU",
    alerts: [
      {
        dateTime: new Date("2022-08-06 20:12:45.442794").toUTCString(),
        type: "accident",
        typeVal: "Accident",
        value: "",
      },
      {
        dateTime: new Date("2022-07-06 20:12:45.442794").toUTCString(),
        type: "unauthorizedmovement",
        typeVal: "Unauthorized Movement",
        value: "",
      },
      {
        dateTime: new Date("2022-08-05 20:12:45.442794").toUTCString(),
        type: "battery",
        typeVal: "Battery",
        value: "9",
      },
      {
        dateTime: new Date("2022-04-06 20:12:45.442794").toUTCString(),
        type: "tpms",
        typeVal: "TPMS",
        value: "LOW(LF)",
      },
    ],
  },
  {
    id: 36,
    vehicle: "SkutKar #36",
    type: "Car",
    battery: 22,
    availability: "nonresponding",
    TPMS: "OK",
    DTC: "OK",
    location: {
      address: {
        city: "City2",
        country: "Country",
        line1: "Addr line 1",
        line2: "Addr line 2",
        postalCode: "13453",
        stateOrProvince: "NY",
      },
      latitude: -30.2,
      longitude: 150.4,
    },
    trackableId: "165790105778280IB3VF",
    alerts: [
      {
        dateTime: new Date("2022-08-06 20:12:45.442794").toUTCString(),
        type: "accident",
        typeVal: "Accident",
        value: "",
      },
      {
        dateTime: new Date("2022-07-06 20:12:45.442794").toUTCString(),
        type: "unauthorizedmovement",
        typeVal: "Unauthorized Movement",
        value: "",
      },
      {
        dateTime: new Date("2022-08-05 20:12:45.442794").toUTCString(),
        type: "battery",
        typeVal: "Battery",
        value: "9",
      },
      {
        dateTime: new Date("2022-04-06 20:12:45.442794").toUTCString(),
        type: "tpms",
        typeVal: "TPMS",
        value: "LOW(LF)",
      },
    ],
  },
  {
    id: 690,
    vehicle: "Skutr #690",
    type: "Scooter",
    battery: 100,
    availability: "reserved",
    TPMS: "OK",
    DTC: "OK",
    location: {
      address: {
        city: "City2",
        country: "Country",
        line1: "Addr line 1",
        line2: "Addr line 2",
        postalCode: "13453",
        stateOrProvince: "NY",
      },
      latitude: -25.2,
      longitude: 150.5,
    },
    trackableId: "1657901090234GJPDI33",
    alerts: [
      {
        dateTime: new Date("2022-08-06 20:12:45.442794").toUTCString(),
        type: "accident",
        typeVal: "Accident",
        value: "",
      },
      {
        dateTime: new Date("2022-07-06 20:12:45.442794").toUTCString(),
        type: "unauthorizedmovement",
        typeVal: "Unauthorized Movement",
        value: "",
      },
      {
        dateTime: new Date("2022-08-05 20:12:45.442794").toUTCString(),
        type: "battery",
        typeVal: "Battery",
        value: "9",
      },
      {
        dateTime: new Date("2022-04-06 20:12:45.442794").toUTCString(),
        type: "tpms",
        typeVal: "TPMS",
        value: "LOW(LF)",
      },
    ],
  },
  {
    id: 61,
    vehicle: "Skutr #61",
    type: "Scooter",
    battery: 56,
    availability: "available",
    TPMS: "OK",
    DTC: "OK",
    location: {
      address: {
        city: "City3",
        country: "Country",
        line1: "Addr line 1",
        line2: "Addr line 2",
        postalCode: "13453",
        stateOrProvince: "NY",
      },
      latitude: 30.2,
      longitude: 150.5,
    },
    trackableId: "165790044824192TKA5O",
    alerts: [
      {
        dateTime: new Date("2022-08-06 20:12:45.442794").toUTCString(),
        type: "accident",
        typeVal: "Accident",
        value: "",
      },
      {
        dateTime: new Date("2022-07-06 20:12:45.442794").toUTCString(),
        type: "unauthorizedmovement",
        typeVal: "Unauthorized Movement",
        value: "",
      },
      {
        dateTime: new Date("2022-08-05 20:12:45.442794").toUTCString(),
        type: "battery",
        typeVal: "Battery",
        value: "9",
      },
      {
        dateTime: new Date("2022-04-06 20:12:45.442794").toUTCString(),
        type: "tpms",
        typeVal: "TPMS",
        value: "LOW(LF)",
      },
    ],
  },
  {
    id: 69,
    vehicle: "Skutr #69",
    type: "Scooter",
    battery: 22,
    availability: "unauthorizedmovement",
    TPMS: "OK",
    DTC: "OK",
    location: {
      address: {
        city: "City3",
        country: "Country",
        line1: "Addr line 1",
        line2: "Addr line 2",
        postalCode: "13453",
        stateOrProvince: "NY",
      },
      latitude: 10.2,
      longitude: 150.5,
    },
    trackableId: "1657900810967PLND5QI",
    alerts: [
      {
        dateTime: new Date("2022-08-06 20:12:45.442794").toUTCString(),
        type: "accident",
        typeVal: "Accident",
        value: "",
      },
      {
        dateTime: new Date("2022-07-06 20:12:45.442794").toUTCString(),
        type: "unauthorizedmovement",
        typeVal: "Unauthorized Movement",
        value: "",
      },
      {
        dateTime: new Date("2022-08-05 20:12:45.442794").toUTCString(),
        type: "battery",
        typeVal: "Battery",
        value: "9",
      },
      {
        dateTime: new Date("2022-04-06 20:12:45.442794").toUTCString(),
        type: "tpms",
        typeVal: "TPMS",
        value: "LOW(LF)",
      },
    ],
  },
];

function NewDashboard() {
  return (
    <>
      <Container fixed>
        <div
          style={{ display: "flex", flexDirection: "row", flexWrap: "wrap" }}
        >
          <WidgetWrap>
            <h3>Trackables</h3>
            <BarChartCylinder />
          </WidgetWrap>
          <WidgetWrap class={"mapMarker"}>
            <div style={{ "max-height": "320px", overflow: "hidden" }}>
              <MyMapComponent data={mapData} />
            </div>
          </WidgetWrap>
          <WidgetWrap>
            <h3>Event Volume</h3>
            <EventVolume />
          </WidgetWrap>
          <WidgetWrap>
            <h3>API Volume</h3>
            <DoubleDonut />
          </WidgetWrap>
          <WidgetWrap>
            <h3>Alerts</h3>
            {/* <StatedTrackable dataType="states" /> */}
            <BarChartCylinder />
          </WidgetWrap>
          <WidgetWrap>
            <h3>Usage</h3>
            <DoughnutChart />
          </WidgetWrap>
        </div>
        {/* <h2>Trackables List</h2>
          <DataGrid/> */}
      </Container>
    </>
  );
}

export default NewDashboard;
